// @ts-nocheck

import { AnalyticService } from '../../classes/service';
import { TServiceName } from '../types';
import eventsHandlersMapper from './microsoft_ads_events';
import { MicrosoftAdsSDK } from '@frontstoreRwd/modules/analytics/services/microsoft_ads/microsoft_ads_sdk';
import { TMicrosoftAdsEvent } from '@frontstoreRwd/modules/analytics/services/microsoft_ads/microsoft_ads_types';
import customerPrivacy from '@frontstoreRwd/modules/customer_privacy';
import { $on } from '@core/tools/event_bus';
import { CONSENTS_SAVED } from '@frontstoreRwd/modules/consents/classes/consents_api/event_names';
import { ConsentsGroup } from '@frontstoreRwd/modules/consents/classes/consents_group';
import { CONSENT_NAMES } from '@storefrontFeatures/customer_privacy/consents/consents_constants';

export class MicrosoftAdsService extends AnalyticService<MicrosoftAdsService> {
    private _uetq: any;
    private _uetgId: string;

    protected _events: TMicrosoftAdsEvent = eventsHandlersMapper;

    constructor(name: TServiceName, uetg: string) {
        super(name);
        this._uetgId = uetg;
    }

    public async setup(): Promise<void> {
        await MicrosoftAdsSDK.create();

        window['uetq'] = window['uetq'] || [];
        this._uetq = window['uetq'];

        if (customerPrivacy.isEnabled()) {
            this._setDefaultConsents();
            this._updateConsents();
        }

        const config = {
            ti: this._uetgId,
            q: window['uetq']
        };

        this._uetq = new UET(config);

        this._uetq.push('pageLoad');

        this._isSetuped = true;
    }

    private _setDefaultConsents() {
        const defaultConsents = {
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            analytics_storage: 'denied'
        };

        this._uetq.push('consent', 'default', defaultConsents);
    }

    private _updateConsents(): void {
        let updateConsents = false;
        const updatedConsents = {
            ad_storage: 'denied'
        };

        customerPrivacy.onMarketingConsentGranted(() => {
            updatedConsents.ad_storage = 'granted';
            updateConsents = true;
        });

        if (updateConsents) {
            this._uetq.push('consent', 'update', updatedConsents);
        }

        $on(CONSENTS_SAVED, (consentsGroup: ConsentsGroup) => {
            const grantedNames = consentsGroup.getGranted().map((consent) => consent.getName());

            const consents = {
                ad_storage: grantedNames.indexOf(CONSENT_NAMES.marketingConsent) > -1 ? 'granted' : 'denied'
            };

            this._uetq.push('consent', 'update', consents);
        });
    }

    public send({ eventName, eventParameters }: { eventName: string; eventParameters: Record<string, any> }): void {
        this._uetq.push('event', eventName, eventParameters);
    }
}
